import store from "@/store/store";
export default {
  userStartedGuideStatus(username) {
    return localStorage.getItem(`${username}StartedGuide`);
  },
  userEndedGuideStatus(username) {
    return localStorage.getItem(`${username}EndedGuide`);
  },

  guideShouldStart(username) {
    return this.userEndedGuideStatus(username) ? false : true;
  },

  guideIsActive(username) {
    return this.userStartedGuideStatus(username) && !this.userEndedGuideStatus(username);
  },

  handleDemoGuideStatus() {
    const temporaryLoginEmail = store.state.temporaryLoginEmail;
    const username = store.state.user.username;
    const postDemoGuide = store.state.postDemoGuide;
    if (
      (postDemoGuide && username == temporaryLoginEmail && this.guideShouldStart(username)) ||
      (this.guideIsActive(username) && this.guideShouldStart(username))
    ) {
      this.startDemoGuide(username);
    }
  },

  startDemoGuide(username) {
    store.commit("setPostDemoGuide", true);
    store.commit("setDemoGuideCurrentStep", 1);
    store.commit("showDemoGuide", true);
    localStorage.setItem(`${username}StartedGuide`, "true");
  },

  setDemoGuideEnded(username) {
    localStorage.setItem(`${username}EndedGuide`, "true");
  },

  getStandardTemplates(isProduction, solution){
    switch(solution){
      case "shopify":
        return isProduction ? standardTemplatesShopify : stagingStandardTemplatesShopify
      case "other":
        return isProduction ? standardTemplatesOther : stagingStandardTemplatesOther
    }
  },

  getVariantVariationSets(demoType){
    console.log(demoType)
    switch(demoType){
      case "Other":
        return require("@/assets/data/variableVariationsOther.json")
      case "OtherHouse":
        return require("@/assets/data/variableVariationsOtherHouse.json")
      case "OtherSports":
        return require("@/assets/data/variableVariationsOtherSports.json")
      case "OtherBeauty":
        return require("@/assets/data/variableVariationsOtherBeauty.json")
      case "OtherLifestyle":
        return require("@/assets/data/variableVariationsOtherLifestyle.json")
      case "OtherElectronics":
        return require("@/assets/data/variableVariationsOtherElectronics.json")
      case "OtherFurniture":
        return require("@/assets/data/variableVariationsOtherFurniture.json")
      case "OtherFood":
        return require("@/assets/data/variableVariationsOtherFood.json")
    }



  },

  getDemoTypeUrlParam(demoType) {
    if(demoType.toLowerCase().includes("shopify")){
      return "Shopify"
    }
    if(demoType.toLowerCase().includes("other")){
      return "Other"
    }

  },

  setDemoType(type, selectedTemplate) {
    return type+selectedTemplate.value
  }
};

const stagingStandardTemplatesShopify = [
  {
    name: "Fashion",
    id: 803,
    value : ""
  }
]

const stagingStandardTemplatesOther = [
  {
    name: "Fashion",
    id: 804,
    value : ""
  },
  {
    name: "Elektronik",
    id: 1040,
    value : "Electronics"
  }
]
const standardTemplatesShopify = [
  {
    name: "Fashion",
    id: 873,
    value : ""
  },
  {
    name: "Hus og have",
    id: 1471,
    value : "House"
  },
  {
    name: "Sport og sundhed",
    id: 1468,
    value : "Sports"
  },
  {
    name: "Skønhed og personlig pleje",
    id: 1470,
    value : "Beauty"
  },
  {
    name: "Livsstil og fritid",
    id: 1469,
    value : "Lifestyle"
  },
  {
    name: "Elektronik",
    id: 1467,
    value : "Electronics"
  },
  {
    name: "Mad og drikke",
    id: 1448,
    value : "Food"
  }
]
const standardTemplatesOther = [
  {
    name: "Fashion",
    id: 888,
    value : ""
  },
  {
    name: "Hus og have",
    id: 1440,
    value : "House"
  },
  {
    name: "Sport og sundhed",
    id: 1441,
    value : "Sports"
  },
  {
    name: "Skønhed og personlig pleje",
    id: 1442,
    value : "Beauty"
  },
  {
    name: "Livsstil og fritid",
    id: 1443,
    value : "Lifestyle"
  },
  {
    name: "Elektronik",
    id: 1446,
    value : "Electronics"
  },
  {
    name: "Mad og drikke",
    id: 1451,
    value : "Food"
  }
]